/* eslint-disable react/no-array-index-key */
import CenteredContent from 'components/CenteredContent/CenteredContent';
import GridList from 'components/GridList/GridList';
import Skeleton from 'components/Skeleton';
import useDevice from 'hooks/useDeviceType';

import useStyles from './styles';

const HubsGridSkeleton = () => {
  const styles = useStyles();
  const { isDesktop } = useDevice();

  const renderingPageData = () =>
    [...Array(2)].map((_, index) => (
      <div key={index} className={styles.skeletonGridItem}>
        <Skeleton />
      </div>
    ));

  return (
    <div className={styles.skeletonRoot}>
      <CenteredContent>
        <div className={styles.separation}>
          <div className={styles.skeletonActions}>
            {[...Array(2)].map((_, index) => (
              <div className={styles.skeletonActionHolder} key={index}>
                <div className={styles.skeletonAction}>
                  <Skeleton height={32} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.skeletonGridHolder}>
          <GridList>{renderingPageData()}</GridList>
        </div>
        <div className={styles.skeletonPaginationHolder}>
          <Skeleton />
          {isDesktop && <Skeleton />}
        </div>
      </CenteredContent>
    </div>
  );
};

export default HubsGridSkeleton;
